<template>
  <div class="f1-step" :class="{ active: active }">
    <div class="f1-step-icon" @click="$emit('click')">
      <i :class="tab.icon"></i>
    </div>

    <p>{{ $t(tab.title) }}</p>
  </div>
</template>

<script>
// @vuese
// Zakładka kreatora
// @group Wizard
export default {
  name: 'Tab',
  props: {
    // zakładka
    tab: {
      type: Object,
      required: true
    },
    // czy aktywna
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.f1-step-icon {
  cursor: pointer;
}
</style>
